// Central authenticated axios client — Phase A · signed JWT.
//
// Behaviour:
//   - Reads the stored user object from localStorage (same key `useAuth` writes to).
//   - When a token is present, attaches `Authorization: Bearer <token>` to every request.
//   - Does NOT install a global 401 redirect interceptor in this batch — callers surface
//     the backend error on the current screen (product-delete relies on this). Global
//     token-expiry handling can be designed in Batch S1.
//
// Base URL is read from REACT_APP_BACKEND_URL (same convention as existing modules).
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem("user");
    if (raw) {
      const stored = JSON.parse(raw);
      if (stored && typeof stored.token === "string" && stored.token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${stored.token}`;
      }
    }
  } catch {
    // Malformed localStorage — proceed without the header. Backend will 401 if the
    // endpoint requires auth; the caller surfaces the error to the user.
  }
  return config;
});

export default api;
export { API };
